import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {useAppDispatch, RootState} from "../../store/store";
import {fetchMyCases, resetFilters, updateQueryFilters} from "../../store/queueSlice";
import {QueueTable} from "../../components/queue-table/QueueTable";
import {useQueueSearchParams} from "../../hooks/useQueueSearchParams";

export const CasesMine: React.FC = () => {
  const dispatch = useAppDispatch();
  const relocationCases = useSelector((state: RootState) => state.queue.casesMine.list);
  const isLoading = useSelector((state: RootState) => state.queue.casesMine.isLoading);
  const isEmpty = useSelector((state: RootState) => state.queue.casesMine.isEmpty);

  // filters TODO: Custom useFilter selector
  const filterByStatus = useSelector((state: RootState) => state.queue.filters.status.value);
  const filterByPriority = useSelector((state: RootState) => state.queue.filters.priority.value);
  const filterByCreatedAt = useSelector((state: RootState) => state.queue.filters.createdAt.value);
  const filterByGroup = useSelector((state: RootState) => state.queue.filters.group.value);
  const filterByCode = useSelector((state: RootState) => state.queue.filters.unitCode.value);
  const filterByPageNumber = useSelector((state: RootState) => state.queue.filters.pagination.number);
  const filterByPageSize = useSelector((state: RootState) => state.queue.filters.pagination.size);
  const filterByIsLatam = useSelector((state: RootState) => state.queue.filters.isLatam.value);
  const filterByTask = useSelector((state: RootState) => state.queue.filters.task.value);

  const {
    isQueryFilters,
    pageNumber,
    pageSize,
    assignedTo,
    unitCode,
    status,
    group,
    priority,
    unassigned,
    createdAt,
    isLatam,
    task,
    setSearchParamsSync,
  } = useQueueSearchParams();

  // on initial load
  useEffect(() => {
    if (!isQueryFilters) {
      dispatch(fetchMyCases());
      return;
    }

    // if Query Param Filters update filters to trigger useEffect. TODO: DRY
    dispatch(
      updateQueryFilters({
        pageNumber,
        pageSize,
        assignedTo,
        unitCode,
        status,
        group,
        priority,
        unassigned,
        createdAt,
        isLatam,
        task,
      })
    );

    return () => {
      dispatch(resetFilters());
    };
  }, []);

  // filters
  useEffect(() => {
    setSearchParamsSync(filterByPageNumber, "pageNumber");
    setSearchParamsSync(filterByPageSize, "pageSize");
    setSearchParamsSync(filterByCode, "unitCode");
    setSearchParamsSync(filterByStatus, "status");
    setSearchParamsSync(filterByGroup, "group");
    setSearchParamsSync(filterByPriority, "priority");
    setSearchParamsSync(filterByCreatedAt, "createdAt");
    setSearchParamsSync(filterByIsLatam, "isLatam");
    setSearchParamsSync(filterByTask, "task");

    dispatch(fetchMyCases());
  }, [
    filterByPriority,
    filterByCreatedAt,
    filterByGroup,
    filterByStatus,
    filterByCode,
    filterByPageNumber,
    filterByPageSize,
    filterByIsLatam,
    filterByTask,
  ]);

  return (
    <QueueTable
      relocationCases={relocationCases}
      isLoading={isLoading}
      isEmpty={isEmpty}
      handleUpdate={() => {
        dispatch(fetchMyCases());
      }}
    />
  );
};
